import { z } from "zod";

const NumericValueSchema = z.union([z.number(), z.null()]);
const StringValueSchema = z.union([z.string(), z.null()]);

const PFAScenarioInputsToCapture = z.object({
    "PV size (kW)": NumericValueSchema,
    "ESS size (kWh)": NumericValueSchema,   
    "Number of chargers (Units)": NumericValueSchema,
    "Total Project Cost": NumericValueSchema,
    "Project Annual Revenue": NumericValueSchema,
    "Revenue Escalator": NumericValueSchema,
    "Project Annual Opex": NumericValueSchema,
    "Opex Escalator": NumericValueSchema,
    "Developer Fee": NumericValueSchema,
    "Project Location (State Code)": StringValueSchema,
    "Month and Year PIS/COD (mm/dd/yyyy)": StringValueSchema,
    "Lifetime of Project": NumericValueSchema,
    "Expected Market Value of Project in 5 years": NumericValueSchema,
});

const ProjectPricingScenarioInputsToCapture = z.object({
    "Location (State)": StringValueSchema,
    "System Size (kW)": NumericValueSchema,
    "Cost ($/kW)": NumericValueSchema,
    "Lifetime (years)": NumericValueSchema,
    "OpEx ($)": NumericValueSchema,
    "Other Revenue ($)": NumericValueSchema,
    "Upfront Rebates ($)": NumericValueSchema,
    "Debt ($)": NumericValueSchema,
    "Interest Rate (%)": NumericValueSchema,
    "Debt Term (years)": NumericValueSchema,
    "Target IRR (%)": NumericValueSchema,
});

const PropertyRiskAnalysisInputsToCapture = z.object({
    "Address": StringValueSchema,
});

const LoiGenerationInputsToCapture = z.object({
    "Address": StringValueSchema,
    'Estimated Annual Production (kWh)': NumericValueSchema,
    'PV size (kW)': NumericValueSchema,
    'Roof Size (Square Feet)': NumericValueSchema,
    'Tenant Occupied Area (Square Feet)': NumericValueSchema,
    'StreetAddress': StringValueSchema,
    'County': StringValueSchema,
    'Utility Name': StringValueSchema,
});

export const QATConversationObjectSchema = z.object({
    inputs: z.object({
        'pfa-scenario': PFAScenarioInputsToCapture.nullable().optional(),
        'project-pricing-scenario': ProjectPricingScenarioInputsToCapture.nullable().optional(),
        'property-risk-screening': PropertyRiskAnalysisInputsToCapture.nullable().optional(),
        'loi-generation': LoiGenerationInputsToCapture.nullable().optional(),
    }),
    analysis_runs_history: z.object({
        "pfa-scenario": z.number().default(0),
        "project-pricing-scenario": z.number().default(0),
        'property-risk-screening': z.number().default(0),
        "loi-generation": z.number().default(0),
    }),
    user_requested_action: z.enum(['pfa-scenario', 'project-pricing-scenario', 'property-risk-screening', 'loi-generation']).nullable().optional(),
    user_completed_action: z.enum(['pfa-scenario', 'project-pricing-scenario', 'property-risk-screening', 'loi-generation']).nullable().optional(),
    next_message: z.string(),
    next_prompt_suggestions: z.array(z.string()),
});

export type QATConversationObjectType = z.infer<typeof QATConversationObjectSchema>;
